// extracted by mini-css-extract-plugin
module.exports = {"link":"review-cards-list_link__wsT4E","listItem":"review-cards-list_listItem__JEBVT","noResults":"review-cards-list_noResults__EL1qD"};